<template>
  <v-app id="pipefish-timesheet">
    <!-- <core-filter /> -->
    <core-toolbar/>
    <utility-loadingDialog
      :loadingDialog="loadingDialog"
      :loadingText="loadingText"
    />
    <core-drawer v-if="userProfile.GivenName"/>
    <core-view v-if="doneLoading"/>
  </v-app>
</template>
<script>
import {
  mapState,
  mapMutations,
  mapActions
} from 'vuex'

import jwtDecode from 'jwt-decode'

export default {
  data: () =>({
    doneLoading: false,
    loadingDialog: false,
    loadingText: "Loading",
    swUpdated: false,
    registrationUpdated: false,
  }),
  computed: {
    ...mapState('app', ['userProfile']),
    approvalRequested: function() {
      if(this.$approvals.get("approvalObject")) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('api', ['getPractices']),
    ...mapMutations('api', ['setProfileImage', 'setUserName', 'setUserInfo']),
    ...mapMutations('app', ['setUserProfile']),
    proceedToApprovals() {
      var approvalObject = JSON.parse(this.$approvals.get("approvalObject"))
      this.$router.push({
        name: 'Approval',
        params: {
          approval_id: approvalObject.params.approval_id,
          type: approvalObject.params.type,
          secret: approvalObject.params.secret
        }
      })
      this.$approvals.remove('approvalObject')
    },
    swUpdatedHandler (e) {
      this.registrationUpdated = e.detail;
      this.swUpdated = true;
    }, 
    refreshApp () {
      this.swUpdated = false;
      if (!this.registrationUpdated || !this.registrationUpdated.waiting) { 
        return; 
      }
      
      this.registrationUpdated.waiting.postMessage('skipWaiting');
      window.location.reload();
      
    },
    getUserProfile(profile) {
      var self = this
      // Register User in timesheet DB if doesn't already exist
      self.$timesheetApi.getUser(profile.id || profile.oid).then(response => {
        self.setUserProfile(response)
        // Only show view once the current logged in user's info is retrieved
        self.doneLoading = true
        self.loadingDialog = false

        if(self.approvalRequested) {
          self.proceedToApprovals()
        }
      }, err => {
        // Register user, since they are not in dB
        console.log("User does not exist in system, registering user")
        self.loadingText = "Registering User.."
        const newUser = {
          GivenName: profile.givenName || profile.given_name,
          Surname: profile.surname || profile.family_name,
          EmailAddress: profile.mail || profile.userPrincipalName || profile.email || profile.unique_name,
          ExternalIdentifier: profile.id || profile.oid,
          IsAdmin: false,
          IsActive: true
        }
        self.$timesheetApi.registerUser(newUser).then(response => {
          self.setUserProfile(response);
          
          self.doneLoading = true
          self.loadingDialog = false

          if(self.approvalRequested) {
            self.proceedToApprovals()
          }
        })
      })
    }
  },
  created() {

    document.addEventListener(
      'swUpdated', this.swUpdatedHandler, {once: true}
    )

    var self = this

    // If the user has logged in, then get their profile
    if(this.$authService.isAuthenticated()) {

      this.loadingDialog = true;
      this.loadingText = "Signing in...."

      self.$authService.getMSGraphToken().then(token => {
        
        /* set the header for all request for timesheetApi */
        self.$timesheetApi.setHeader(token)
        
        // Get user profile from MS graph
        self.$msGraphApi.getProfile(token).then(profile => {
          // console.log(profile)
          self.getUserProfile(profile)

        }).catch(err => {
          // If microsoft graph is down, use the JWT token to get user info
          var profile = jwtDecode(token)
          self.getUserProfile(profile)
        })

        // User has logged in, so get the image from MSgraph is one exists
        self.$msGraphApi.getImage(token).then(image => {
          const url = window.URL || window.webkitURL
          const blobURL = url.createObjectURL(image)
          self.setProfileImage(blobURL)
        }, err => {
          console.log("User has no image")
        })
      })
    } else {
      self.doneLoading = true
    }
  }
}
</script>

<style lang="scss">

@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
